var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotionStandby(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_154155243566065540676324562667342868792",
    d: "M23.281 18.857c.397 0 .719.322.719.719v3.705c0 .397-.322.719-.719.719h-3.705c-.397 0-.719-.322-.719-.719 0-.397.322-.718.719-.718h2.987v-2.987c0-.397.321-.719.718-.719zm-22.562 0c.397 0 .718.322.718.719v2.987h2.987c.397 0 .719.321.719.718 0 .397-.322.719-.719.719H.72C.322 24 0 23.678 0 23.281v-3.705c0-.397.322-.719.719-.719zM12.43 6.57c2.699.19 3.573 3.242 3.332 5.556-.102.98-1.648.99-1.544 0 .09-.88.043-2.238-.483-3.129-.013 1.113.03 2.227.032 3.34.016.07.027.142.027.222 0 2.564.003 5.127.11 7.69.047 1.138-1.72 1.134-1.766 0-.083-2.008-.103-4.017-.108-6.027-.084.005-.167.005-.251 0-.005 2.01-.026 4.018-.109 6.026-.046 1.135-1.812 1.14-1.766 0 .106-2.562.11-5.125.11-7.69l.006-.05-.003-.054-.002-.056V9.167c-.44.886-.476 2.133-.39 2.96.103.99-1.443.98-1.545 0-.235-2.268.599-5.241 3.168-5.542.378-.09.797-.093 1.182-.015zm-.539-3.827c.854 0 1.546.692 1.546 1.545 0 .854-.692 1.545-1.546 1.545-.853 0-1.545-.691-1.545-1.545 0-.853.692-1.545 1.545-1.545zM4.424 0c.397 0 .719.322.719.719 0 .397-.322.718-.719.718H1.437v2.987c0 .397-.321.719-.718.719C.322 5.143 0 4.82 0 4.424V.72C0 .322.322 0 .719 0zm18.857 0c.397 0 .719.322.719.719v3.705c0 .397-.322.719-.719.719-.397 0-.718-.322-.718-.719V1.437h-2.987c-.397 0-.719-.321-.719-.718 0-.397.322-.719.719-.719z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_240468028185709971306600231918192338210",
    d: "M0 0H24V24H0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_25137695327973243120882947048953509413",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_265693774112996578529359610817235894690",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_154155243566065540676324562667342868792"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#hinava_random_uuid_154155243566065540676324562667342868792"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_265693774112996578529359610817235894690)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_240468028185709971306600231918192338210"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_25137695327973243120882947048953509413)",
    xlinkHref: "#hinava_random_uuid_240468028185709971306600231918192338210"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionStandby);
export default __webpack_public_path__ + "static/media/motion-standby.7c2b251b34c61dd69276a09c3bc645dc.svg";
export { ForwardRef as ReactComponent };